import { Card, CardBody, Col } from "reactstrap";
import HoverAnnualFunction from "./HoverAnnualFunction";
import HoverFresherInterview from "./HoverFresherInterview";
import HoverMeetup from "./HoverMeetup";
import { HoverTimelineTitle } from "../../../../constants";
import { HoverTimelineSubTitle } from "../../../../data/bonusUi/Timeline";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const HoverTimeline = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={HoverTimelineTitle} span={HoverTimelineSubTitle} />
        <CardBody>
          <ul className="square-timeline">
            <HoverAnnualFunction />
            <HoverFresherInterview />
            <HoverMeetup />
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HoverTimeline;
